module.exports = __webpack_public_path__ + "static/media/JPEG.80891856.svg";